import { useState } from 'react'
import {
  BannerContainer,
  BannerIcon,
  BannerBody,
  BannerTitle,
  BannerMessage,
  DismissButton,
} from './styles'

const STORAGE_KEY = 'trueye_pwa_welcomed'

export default function PwaWelcomeBanner() {
  const [visible, setVisible] = useState(
    () => !localStorage.getItem(STORAGE_KEY),
  )

  if (!visible) return null

  function dismiss() {
    localStorage.setItem(STORAGE_KEY, 'true')
    setVisible(false)
  }

  return (
    <BannerContainer role="status" aria-live="polite">
      <BannerIcon aria-hidden="true">🎉</BannerIcon>
      <BannerBody>
        <BannerTitle>Welcome to the new TruEye Mobile!</BannerTitle>
        <BannerMessage>
          You're running the new TruEye Mobile. The legacy version will be
          removed soon — you're already ahead of the curve.
        </BannerMessage>
      </BannerBody>
      <DismissButton onClick={dismiss} aria-label="Dismiss welcome banner">
        ✕
      </DismissButton>
    </BannerContainer>
  )
}
